/**
 * SocialFocus — Hide Feeds, Block Shorts & Remove Distractions
 *
 * Declares a single web-accessible-resource,
 * `extension/screens/privacyPolicy/privacyPolicyForTab.js`, matched to every origin
 * (<all_urls>) with no `use_dynamic_url`. The path is deep and vendor-specific, and it
 * is reachable from any page at a fixed URL — so its presence is conclusive, though it
 * is the only path exposed.
 *
 * Manifest verified against version 7.7.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'abocjojdmemdpiffeadpdnicnlhcndcg';

export const socialFocus: ExtensionDefinition = {
  id: ID,
  name: 'SocialFocus — Hide Feeds, Block Shorts & Remove Distractions',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 40_000,
  notes:
    'Exposes a single static WAR (privacyPolicyForTab.js) to every origin with no ' +
    'dynamic URL. Its distinctive deep path makes one fetch conclusive.',
  signals: [
    {
      id: 'war-privacy-policy-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch extension/screens/privacyPolicy/privacyPolicyForTab.js — the extension\'s ' +
        'sole WAR, exposed to every origin at a fixed URL.',
      weight: 1,
      run: () =>
        probeFetch(ID, 'extension/screens/privacyPolicy/privacyPolicyForTab.js'),
    },
  ],
};
